import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { Typography, Box, useTheme } from '@mui/material'
import { Controller, useForm, FormProvider } from "react-hook-form";

import { fileActions, documentsActions, workflowActions, addTitleLegoCurrent } from '../../store/actions'
import { InputField, UseImage, CustomLoadingOverlay, GenericContainer, Buttons, GeoLocationGeneric, GenericContainerForm } from '../../components'
import { useStyles } from './IdentityValidationStyles'
import { coreFunctions } from '../../utils';
import noFingerImg from '../../assets/noFinger.svg'
import { useTranslation } from 'react-i18next';

export default function SkipJustificationHand(props) {
    const theme = useTheme()
    const formMethods = useForm({ mode: "onChange" });
    const { control, handleSubmit, register, formState } = useForm({ mode: "onBlur" });

    const location = useLocation()
    const localStyles = useStyles()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [loadView, setLoadView] = useState(false)
    const [sections, setSections] = useState([])

    const [activeGeolocation, setActiveGeolocation] = useState(true)
    const [latitude, setLatitude] = useState("")
    const [longitude, setLongitude] = useState("")
    const [loadStatusStage, setLoadStatusStage] = useState(false)
    const [isFlowGroup, setIsFlowGroup] = useState(false)
    const [capturedHand, setCapturedHand] = useState(0)
    const [saveRegisterMinutiae, setSaveRegisterMinutiae] = useState(false)
    const [saveNextStep, setSaveNextStep] = useState(false)

    const file = useSelector(state => state.FileInfo)
    // const uploadSecDoc = useSelector(state => state.UploadSections)
    const uploadMinData = useSelector(state => state.UploadMinutiaData)
    const registroStatusStage = useSelector(state => state.RegStatusStage)

    const folioId = location.state.folioId
    const actorId = location.state.actorId
    const { t } = useTranslation();

    const Options = [
        { Label: 'Discapacidad física', Value: 'Discapacidad física' },
        { Label: 'Falta de extremidad', Value: 'Falta de extremidad' },
        { Label: 'Marca de nacimiento', Value: 'Marca de nacimiento' }
    ]

    useEffect(() => {
        dispatch(fileActions.GetFileInfo(location.state.folioId))
        let varFlowGroup = sessionStorage.getItem('isFlowGroup')
        setIsFlowGroup(varFlowGroup)
        setCapturedHand(location.state.capturedHand === undefined ? 0 : location.state.capturedHand)
    }, [])

    useEffect(() => {
        setLoadView(file.loading)
        if (file.items != undefined && file.items?.Stage != null) {
            let actGeoloc = file.items.Stage.Properties.find(item => item.Name == "ActiveGeolocation")?.Value
            console.log("actGeoloc-----PARAM--- CONFIG------ ", actGeoloc)
            setActiveGeolocation(actGeoloc === undefined ? true : actGeoloc)

            if (file.items.Stage.DocumentalCategory != undefined && file.items.Stage.DocumentalCategory != null) {
                const secs = file.items.Stage.DocumentalCategory.DocumentalGroups[0].DocumentTypes[0].Sections
                const ids = secs.filter((sec) => sec.CaptureType == "Minutiae")
                setSections(ids)
            }
            if (file.items.Product == "Solicitud Grupal") {
                setIsFlowGroup(true)
            }
        }
    }, [file])

    useEffect(() => {
        console.log("uploadMinData.items------------ :", uploadMinData.items, saveRegisterMinutiae)
        setLoadView(uploadMinData.loading)
        if (uploadMinData.items != undefined && uploadMinData.items?.Result != null && saveRegisterMinutiae) {
            if (uploadMinData.items.Result?.Id != null || uploadMinData.items.Result?.Id != undefined) {
                if (capturedHand == 1) {
                    setSaveRegisterMinutiae(false)
                    setSaveNextStep(true)
                } else {
                    let nextComponent = 'HelpHandsComponent'
                    let capturedHand = 1
                    coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, capturedHand } })
                }
            }
        }
        else if (uploadMinData.error != undefined && saveRegisterMinutiae) {
            alert(uploadMinData.error)
            setSaveRegisterMinutiae(false)
            setSaveNextStep(false)
        }
    }, [uploadMinData])

    useEffect(() => {
        if (saveNextStep) {
            dispatch(workflowActions.RegisterStatusStage({
                File_id: folioId,
                Status: "CargaMinucias"
            }))
            setLoadStatusStage(true)
            setSaveNextStep(false)
        }
    }, [saveNextStep])

    useEffect(() => {
        console.log("registroStatusStage.items------- ", registroStatusStage.items)
        setLoadView(registroStatusStage.loading)
        if (registroStatusStage.items != undefined && registroStatusStage.items != null && loadStatusStage) {
            setLoadStatusStage(false)
            const nextComponent = 'ExternalValidations'
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId } })
        }
    }, [registroStatusStage])

    let handleBack = () => {
        const nextComponent = 'FingerSelectCapture'
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId } })
    }

    let sendSection = (data) => {
        let sectionIdValue = capturedHand == 0 ? sections.find(item => item.CaptureOptions == "{\"FingerNumber\":2}")?.Id : sections.find(item => item.CaptureOptions == "{\"FingerNumber\":7}")?.Id

        setSaveRegisterMinutiae(true)
        const dataToSend = {
            B64Content: null,
            FileId: folioId,
            Actor_Id: actorId,
            SkipActor: (isFlowGroup ? null : true),
            SectionId: sectionIdValue,
            Extension: null,
            Skip: true,
            SkipReason: data["rdOptions"]
        }
        console.log("-----Upload minutiae----- data-----------------Request...", dataToSend)
        dispatch(documentsActions.UploadMinutiae(dataToSend))
    }

    useEffect(() => {
        dispatch(addTitleLegoCurrent(capturedHand == 0 ? 'No capturar huellas mano izquierda' : 'No capturar huellas mano derecha'))
    }, [capturedHand])

    return (<GenericContainer>
        <FormProvider {...formMethods} >
            <GenericContainerForm>
                {activeGeolocation &&
                    <GeoLocationGeneric SuccessFN={(latitude, longitude) => {
                        console.log("succes,latitude, longitude ", latitude, longitude);
                        setLatitude(latitude);
                        setLongitude(longitude);
                    }}
                        ErrorFN={(error) => console.log('error', error)}
                    />
                }
                {/* <Typography variant="h6"><b>{capturedHand == 0 ? 'No capturar huellas mano izquierda' : 'No capturar huellas mano derecha'}</b></Typography> */}
                <UseImage src={noFingerImg} className={localStyles.imgFinger} id='noFingerImg' />
                <Typography variant="subtitle1" >Selecciona el motivo por el cual no se realizará la captura de huellas dactilares.</Typography>

                <InputField
                    inputType="radio"
                    control={control}
                    name='rdOptions'
                    radioValues={Options}
                    validations={{ required: true }}
                    error={!!formState.errors['rdOptions']}
                    helperText={formState.errors['rdOptions']?.message}
                    required={true}
                />

                {/* <Box style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'left',
                    width: '100%',
                    padding: "0.5em",
                }}>
                    <InputField type='Radio' id='justification'
                        onChange={(e) => {
                            setJustification(e.target.value)
                        }}
                        Options={options} />
                </Box> */}
            </GenericContainerForm>
            <Buttons
                ConfirmButtonText={capturedHand == 0 ? 'No capturar huellas mano izquierda' : 'No capturar huellas mano derecha'}
                onClickConfirm={handleSubmit(sendSection)}
                CancelButtonText={t("general_cancel")}
                onClickCancel={handleBack} />

            {loadView ?
                <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
                : null}
        </FormProvider >
    </GenericContainer>)
}